import { render, staticRenderFns } from "./UpdateProducts.vue?vue&type=template&id=86306bf4&scoped=true&"
import script from "./UpdateProducts.vue?vue&type=script&lang=js&"
export * from "./UpdateProducts.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProducts.vue?vue&type=style&index=0&id=86306bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86306bf4",
  null
  
)

export default component.exports